import React from "react";
import { Chip, useTheme, alpha } from "@mui/material";

const StatusChip = ({ status, icon, sx = {} }) => {
  const theme = useTheme();

  const s = status ? status.toUpperCase() : "UNKNOWN";

  // Default color (Blue/Info)
  let baseColor = theme.palette.info.main;

  // 1. Success Statuses (Green)
  if (
    [
      "ACTIVE",
      "SENT",
      "COMPLETED",
      "PAID",
      "DELIVERED",
      "OPEN",
      "CASH",
      "ACCEPTED",
      "CONVERTED",
      "APPROVED",
      "EQUITY",
      "CREATE",
      "NON_TAXABLE",
    ].includes(s)
  ) {
    baseColor = theme.palette.success.main;
  }
  // 2. Warning Statuses (Amber/Orange)
  else if (
    [
      "INACTIVE",
      "PENDING",
      "CLOSED",
      "DRAFT",
      "PARTIAL",
      "WAITLIST",
      "LIABILITY",
      "UPDATE",
      "LOW_STOCK",
      "ARCHIVED",
      "TAXABLE",
    ].includes(s)
  ) {
    baseColor = theme.palette.warning.main;
  }
  // 3. Error Statuses (Red)
  else if (
    [
      "LOCKED",
      "FAILED",
      "OVERDUE",
      "CREDIT",
      "EXPIRED",
      "VOIDED",
      "REJECTED",
      "SUSPENDED",
      "CANCELLED",
      "EXPENSE",
      "NOT_SENT",
      "DELETE",
    ].includes(s)
  ) {
    baseColor = theme.palette.error.main;
  }

  return (
    <Chip
      label={s.replace("_", " ")}
      icon={icon}
      size="small"
      sx={{
        backgroundColor: alpha(baseColor, 0.1),
        color: baseColor,
        border: `1px solid ${alpha(baseColor, 0.5)}`,
        fontWeight: "bold",
        fontSize: "0.65rem",
        letterSpacing: "0.5px",
        height: 24,
        "& .MuiChip-icon": {
          color: baseColor,
          marginLeft: "6px",
          marginRight: "-4px",
        },
        ...sx,
      }}
    />
  );
};

export default StatusChip;
